import * as React from "react";

import { UitkCardAloha } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";

import { DefaultCardContents } from "./DefaultCardContents";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const PackageCard = ({ packageItem, index, language }: PackageCardProps) => (
  <UitkCardAloha className="all-t-margin-three">
    <UitkLayoutGrid columns={3}>
      <UitkLayoutGridItem colSpan={1}>
        <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
          <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage={true} />
        </UitkFigure>
      </UitkLayoutGridItem>
      <DefaultCardContents packageItem={packageItem} index={index} language={language} overImage={false} grid={true} />
    </UitkLayoutGrid>
  </UitkCardAloha>
);
